module.exports = __webpack_public_path__ + "img/new-hekaya_0.4e07fecb.jpg";